import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import allActions from "../actions/allActions";
import CreateRegistrationContainer from "../events/eventRegistration/CreateRegistrationContainer";
import Linkpage from "../events/eventRegistration/views/Linkpage";
import SubEventContainer from "../events/SubEventContainer";
import { EventParamTypes } from "../types/types";
import ConsoleHelper from "../utils/logger";

export const SubEventNavigation: React.FC = () => {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { id, subEventId } = useParams<EventParamTypes>();

  const getEventDetails = useCallback(() => {
    dispatch(allActions.eventActions.startGetEventDetails(id));
  }, [id, dispatch]);

  const getAllEvents = useCallback(() => {
    dispatch(allActions.eventActions.getAllEvents({ date: "0", limit: "100" }));
  }, [dispatch]);

  const getParticipants = useCallback(() => {
    dispatch(allActions.participantActions.getParticipants(id));
  }, [id, dispatch]);

  const getSubEventDetails = useCallback(() => {
    dispatch(allActions.eventActions.getSubEventDetails(subEventId));
  }, [subEventId, dispatch]);

  useEffect(() => {
    getAllEvents();
  }, [getAllEvents]);

  useEffect(() => {
    getSubEventDetails();
  }, [getSubEventDetails]);

  useEffect(() => {
    getEventDetails();
  }, [getEventDetails]);

  useEffect(() => {
    getParticipants();
  }, [getParticipants]);

  ConsoleHelper(path);
  return (
    <Switch>
      <Route exact path={path} render={() => <SubEventContainer />} />
      <Route path={`${path}/link`} render={() => <Linkpage />} />
      <Route
        path={`${path}/registration`}
        render={() => <CreateRegistrationContainer />}
      />
    </Switch>
  );
};

export default SubEventNavigation;
